import { render } from "./CreateWizardModule.vue?vue&type=template&id=ca21111e&scoped=true"
import script from "./CreateWizardModule.vue?vue&type=script&lang=js"
export * from "./CreateWizardModule.vue?vue&type=script&lang=js"

import "./CreateWizardModule.vue?vue&type=style&index=0&id=ca21111e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca21111e"]])

export default __exports__